import { call, put, select } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { submitFormDataFailure, submitFormSuccess } from '../redux/actions';
import { submitOD } from '../services/api';
import { selectDraftData } from '../redux/selectors';

export function* submitODSaga({ payload: { step } }) {
  const formData = yield select(getFormValues('transportDestruction'));
  const draftData = yield select(selectDraftData);

  const objects = formData
    .get('addedObjects')
    .toJS()
    .map((item) => {
      const { perishingDate, fidRight, transportType, confirmationDoc, ...rest } = item;
      const { docName, ...docData } = confirmationDoc;
      return {
        ...rest,
        transportType: transportType.value,
        perishingDate: `${perishingDate.month}.${perishingDate.year}`,
        confirmationDoc: { ...docData, docName: docName.value },
      };
    });

  const attaches =
    formData.get('attaches') &&
    formData
      .get('attaches')
      .toJS()
      .map((item) => ({ fileName: item.fileName, fileLink: item.fileLink }));
  const taxInspectionData = formData.get('taxInspectionCode');
  const { isOk, data, error } = yield call(submitOD, {
    ...draftData.toJS(),
    attaches,
    taxInspectionCode: taxInspectionData.value || taxInspectionData,
    taxInspectionAddress: taxInspectionData.taxInspectionAddress,
    taxInspectionTitle: taxInspectionData.label,
    transports: objects,
  });
  if (isOk && data) {
    yield put(submitFormSuccess(data));
    yield put(push({ query: { step } }, { persistQuery: true }));
  } else {
    yield put(submitFormDataFailure(error));
  }
}
